import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { LoginForm } from "@/components/LoginForm";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/lib/i18n";
import { loc } from "@/lib/format";
import { useStorefrontConfig } from "@/lib/storefront";

export function LoginDialog() {
  const { loginOpen, closeLogin } = useAuth();
  const { t, lang } = useI18n();
  const config = useStorefrontConfig();

  return (
    <Dialog open={loginOpen} onOpenChange={(open) => (open ? null : closeLogin())}>
      <DialogContent className="max-w-md rounded-3xl">
        <DialogHeader>
          <DialogTitle className="text-2xl">{t("login.title")}</DialogTitle>
          <DialogDescription>{loc(config.title, lang)}</DialogDescription>
        </DialogHeader>
        <LoginForm />
      </DialogContent>
    </Dialog>
  );
}
